/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 학과정보 탭
 * 버전 : 1.0
 * 파일명 : SchoolListDetailTab02.tsx
 * 작성자 : 강동형
 * 작성일 : 2026-01-30
 * ================================================================
 * 수정 : 2026-02-04, 강동형 : 학과 정보 비어있을때 UI 추가
 * ================================================================ */

import React, { useState } from 'react'
import { Typography, Menu, MenuItem, styled as styledd, Button } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import styled from 'styled-components';
import InputBoxSearch from '../inputbox/InputBoxSearch';
import { AppImage } from 'src/assets/images/AppImage';

// 필터 바 스타일링
const FilterBar = styledd('div')({
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center', 
    backgroundColor:'white',
    });

// 필터 버튼 스타일링
const FilterButton = styledd(Button)({ display: 'flex', alignItems: 'center', marginLeft: 8, backgroundColor: 'white', color: 'black' });

const MajorSpan = styled.span<{$isLast?:boolean}>`
    font-size: 12px;
    padding: 10px 12px;
    border-bottom: ${({$isLast})=>($isLast ? 'none': '1px solid #ddd')};
    width: 100%;
    font-weight: 700;
`;

const EmptyWrapper = styled.div`
    display:flex;
    justify-content: center;
    align-items: center;
    gap: 11px;
    flex-direction: column;
    height: 100%;
`

const EmptySpan = styled.span`
    text-align: center;
    color: #7F7F89;
    font-size: 18px;
    font-weight: 600;
`

interface Props{
    majorList : string[]
}

const SchoolListDetailTab02 = ({majorList}:Props) => {
    const [majorListState,setMajorListState] = useState(majorList)
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [sortCriterion, setSortCriterion] = useState('내림차순');
    const [inputValue,setInputValue] = useState('')

    // 필터 버튼 클릭 이벤트 핸들러
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    };

            // 필터 메뉴 닫기 이벤트 핸들러
    const handleClose = (criterion: string = '') => {
        if (criterion) {
        setSortCriterion(criterion);
        sortSchools(criterion);
        }
        setAnchorEl(null);
    };

    // 학교 목록을 정렬하는 함수
    const sortSchools = (criterion: string) => {
        if (!majorListState) return;
        const sortedSchools = [...majorListState].sort((a, b) => {
            switch (criterion) {
                case '오름차순':
                    return b.localeCompare(a, 'ko');
                case '내림차순':
                    return a.localeCompare(b, 'ko');
            default:
                return 0;
            }
        });
        setMajorListState(sortedSchools);
        };

    const filteredMajors = (majorListState ?? []).filter((item) => {
        if (!inputValue) return true; // inputValue 비었으면 전체
        return item.includes(inputValue); // 포함 검색
    });

  return (
    <div style={{marginTop:'1px', height:'100%'}}>
        {filteredMajors.length === 0 ? 
            <EmptyWrapper>
                <AppImage name='GraduateHatGray'/>
                <EmptySpan>등록된 학과가 없습니다.</EmptySpan>
            </EmptyWrapper>
            :
            <>
            <div style={{height:'35px',marginTop:'8px'}}>
                <InputBoxSearch placeholder="" onChange={(e)=>{setInputValue(e.target.value)}} value={inputValue}/>
            </div>
            <div style={{position:'sticky', marginBottom:'6px'}}>
                <FilterBar>
                    <Typography variant="body2" sx ={{color:'#7F7F89', fontSize:'12px', fontWeight:500}}>
                        총 <span style={{color:'black',fontSize:'16px'}}>{filteredMajors?.length} </span>건
                        </Typography>
                    <div>
                    <FilterButton onClick={handleClick} endIcon={<ArrowDropDownIcon />}>
                        {sortCriterion}
                    </FilterButton>
                    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => handleClose()}>
                        <MenuItem onClick={() => handleClose('내림차순')}>내림차순</MenuItem>
                        <MenuItem onClick={() => handleClose('오름차순')}>오름차순</MenuItem>
                    </Menu>
                    </div>
                </FilterBar>
            </div>
            <div style={{overflowY:'auto', height:'calc(100vh - 570.14px)',width:'100%', display:'flex',flexDirection:'column'}}>
                {filteredMajors?.map((items, index) => {
                    return(
                        <MajorSpan $isLast={index===filteredMajors.length-1}>
                        {items}
                        </MajorSpan>
                )})}
            </div>
            </>
            }
        </div>
  )
}

export default SchoolListDetailTab02